import {useTranslation} from 'react-i18next';
import styles from './TermsItem.module.scss';
import ICON_ARROW from '../../../public/static/auth/ico-greyarrow.svg';
import Anchor from '../../common/component/Anchor';
import CheckBoxV4 from '../../common/component/CheckBoxV4';
import Text from '../../common/component/Text';
import {ITermsItem} from '../type';

interface IProps {
  item: ITermsItem;
  checked: boolean;
  isModal: boolean;
  onChange: (id: number) => void;
}

export default function TermsItem({item, checked, isModal, onChange}: IProps) {
  const {t} = useTranslation();
  const {id, title, detailPath} = item;
  return (
    <CheckBoxV4
      id={`terms-${id}`}
      checked={checked}
      onChange={() => onChange(id)}
      className={cn(styles.checkBox, !isModal && '!items-start')}
      label={
        <label
          htmlFor={`terms-${id}`}
          className={cn('ml-10', !isModal && 'w-full')}
        >
          <Text
            as="span"
            className={cn(
              'light:text-black',
              isModal ? 's12-regular-white' : 's14-regular-white'
            )}
          >
            {title}
          </Text>
        </label>
      }
      additionalElement={
        detailPath ? (
          isModal ? (
            <Anchor pageInfo={detailPath} className="ml-6 mr-auto flex-none">
              <Text className="s12-regular-grey11 underline">
                {t('login_korea_signup_show_link')}
              </Text>
            </Anchor>
          ) : (
            <Anchor pageInfo={detailPath} className="py-6 -my-6 px-9 -mr-9">
              <img src={ICON_ARROW} alt={title} width={6} height={12} />
            </Anchor>
          )
        ) : null
      }
    />
  );
}
